import React from "react";
import Testimonials from "../home/Testimonials";

const TechnologyTestimonials = () => {
  return <Testimonials />;
};

export default TechnologyTestimonials;
